































































































import { Component, Watch } from 'vue-property-decorator'
import { NavMenu } from '@/types/NavBar'
import { mapState } from 'vuex'
import RouterHelper from '@/mixins/RouterHelper.vue'

const menus: NavMenu = [
  { icon: 'icomoon-icon-Matrix', name: 'ConvertFastq', route: 'ConvertFastq' },
  {
    icon: 'icomoon-icon-Preprocess',
    name: 'dataProcessing',
    children: [
      { name: 'DataIntegration', route: 'DataIntegration' },
      { name: 'PreProcessing', route: 'PreProcessing' }
    ]
  },
  { icon: 'icomoon-icon-Analysis',
    name: 'DownstreamAnalysis',
    children: [
      { name: 'Clustering', route: 'Clustering' },
      { name: 'DifferentialExpression', route: 'DifferentialExpression' },
      { name: 'CellTypeAnnotation', route: 'CellTypeAnnotation' },
      { name: 'GeneSetEnrichment', route: 'GeneSetEnrichment' },
      { name: 'TrajectoryAnalysis', route: 'TrajectoryAnalysis' },
      { name: 'CellCommunication', route: 'CellCommunication' },
      { name: 'InferCNV', route: 'InferCNV' }
    ]
  }
  // { icon: 'icomoon-icon-Advanced', name: 'AdvancedDownstreamAnalysis', route: 'AdvancedDownstreamAnalysis' }
  // { icon: 'icomoon-icon-Bulk', name: 'BulkDataDeconvolution', route: 'BulkDataDeconvolution' },
  // { icon: 'icomoon-icon-Knowledge', name: 'KnowledgeGraph', route: 'KnowledgeGraph' },
  // { icon: 'icomoon-icon-Spatial', name: 'SpatialTranscriptomics', route: 'SpatialTranscriptomics' }
]

@Component({
  computed: {
    ...mapState(['currentNavModule'])
  }
})
export default class NavBar extends RouterHelper {
  public isCollapse: boolean = false
  private menus: NavMenu = menus

  /*
    切换英文时调整导航栏宽度 显示完整英文
   */
  get changeNavWidth () {
    return this.$route.params.lang === 'en'
  }
}
